import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Result } from "antd";
import { useMe } from "./useMe";
import {
  ADMIN_SECTION_ROUTE,
  firstAllowedSection,
  isPathAllowed,
} from "./sections";

const NoAccess = () => (
  <Result
    status="403"
    title="Нет доступа"
    subTitle="Для вашей учётной записи не настроен доступ к разделам. Обратитесь к администратору."
  />
);

/**
 * Гейтинг прямых переходов по URL (меню прячет пункты, но не блокирует адресную строку).
 * Оборачивает авторизованный Outlet в App.tsx.
 */
export const SectionGuard = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const meState = useMe();

  if (meState.status === "loading") {
    return null;
  }
  if (meState.status === "error") {
    // Бэк без /cms/me — ведём себя как раньше (fail-open).
    return <>{children}</>;
  }

  const { me } = meState;
  const pathname = location.pathname;
  const inAdminSection =
    pathname === ADMIN_SECTION_ROUTE ||
    pathname.startsWith(`${ADMIN_SECTION_ROUTE}/`);

  if (me.isAdmin) {
    // Супер-админ видит все разделы.
    return <>{children}</>;
  }

  if (inAdminSection || !isPathAllowed(pathname, me.allowedSections)) {
    const fallback = firstAllowedSection(me.allowedSections);
    if (!fallback) {
      return <NoAccess />;
    }
    // Уже на первом доступном, но путь не разрешён (теоретический случай) — не зацикливаемся.
    return pathname === fallback ? (
      <NoAccess />
    ) : (
      <Navigate to={fallback} replace />
    );
  }

  return <>{children}</>;
};
